require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-verifiable-bookmarklets.json") })
        }
      }, "path---blog-verifiable-bookmarklets");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-verifiable-bookmarklets!./.cache/json/blog-verifiable-bookmarklets.json
// module id = 279
// module chunks = 231608221292675